module.exports = __webpack_public_path__ + "assets/img/loda_food.02db615f.jpg";